
<div v-if="visible" ref="confirm" class="cp-confirm mobile">
  <div class="box-mask">
    <div class="box-container" :class="{hasChance: hasChance}">
      <div class="prize"></div>
      <div class="prize-wrapper">
        <Prize
          v-for="(item, index) in prize"
          :key="index"
          :prize="item.icon"
          :name="item.name || item.title"
          :class="`prize prize-${index + 1}`"
        >
        </Prize>
      </div>
      <div class="button">
        <div class="bottom-item confirm" @click="handleAction('yes')"></div>
        <div class="bottom-item cancel" @click="handleAction('cancel')"></div>
      </div>
    </div>
  </div>
</div>
